export default {
  add: 'mdi-plus',
  allLeft: 'mdi-chevron-double-left',
  allRight: 'mdi-chevron-double-right',
  calendar: 'mdi-calendar',
  calendarLock: 'mdi-calendar-lock',
  calendarRange: 'mdi-calendar-range',
  calendarRemove: 'mdi-calendar-remove',
  calendarTime: 'mdi-calendar-clock',
  cancel: 'mdi-close-circle',
  checkboxIndeterminate: 'mdi-minus-box',
  checkboxOff: 'mdi-checkbox-blank-outline',
  checkboxOn: 'mdi-checkbox-marked',
  clear: 'mdi-close',
  close: 'mdi-close',
  complete: 'mdi-check',
  copy: 'mdi-content-copy',
  delete: 'mdi-close', // Delete (e.g. v-chip close)
  delimiter: 'mdi-circle', // For carousel
  download: 'mdi-cloud-download',
  dropdown: 'mdi-menu-down',
  edit: 'mdi-pencil',
  email: 'mdi-email',
  error: 'mdi-alert-octagon',
  excel: 'mdi-file-excel-outline',
  expand: 'mdi-chevron-down-circle',
  external: 'mdi-open-in-new',
  file: 'mdi-paperclip',
  filter: 'mdi-filter-variant',
  first: 'mdi-page-first',
  help: 'mdi-help-circle',
  hide: 'mdi-eye-off',
  info: 'mdi-information',
  last: 'mdi-page-last',
  list: 'mdi-view-list',
  loading: 'mdi-cached',
  login: 'mdi-login-variant',
  logout: 'mdi-logout-variant',
  menu: 'mdi-menu',
  minus: 'mdi-minus',
  next: 'mdi-chevron-right',
  password: 'mdi-lock',
  pdf: 'mdi-file-export-outline',
  plus: 'mdi-plus',
  prev: 'mdi-chevron-left',
  print: 'mdi-printer',
  radioOff: 'mdi-radiobox-blank',
  radioOn: 'mdi-radiobox-marked',
  ratingEmpty: 'mdi-star-outline',
  ratingFull: 'mdi-star',
  ratingHalf: 'mdi-star-half-full',
  ratingCircleEmpty: 'mdi-circle-outline',
  ratingCircleFull: 'mdi-circle',
  ratingCircleHalf: 'mdi-circle-half-full',
  ratingHeartEmpty: 'mdi-heart-outline',
  ratingHeartFull: 'mdi-heart',
  ratingHeartHalf: 'mdi-heart-half-full',
  reset: 'mdi-undo',
  restore: 'mdi-restore',
  save: 'mdi-content-save',
  search: 'mdi-magnify',
  send: 'mdi-send',
  settings: 'mdi-cog',
  sort: 'mdi-chevron-up',
  subgroup: 'mdi-menu-down',
  success: 'mdi-check-circle',
  trash: 'mdi-trash-can',
  unfold: 'mdi-unfold-more-horizontal',
  user: 'mdi-account',
  view: 'mdi-eye',
  warning: 'mdi-alert',
}
